<template>
  <EchartsLayout :option="option"></EchartsLayout>
</template>

<script>
import { getCacheOrRequest } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import EchartsLayout from "@/components/common/EchartsLayout.vue";

export default {
  mixins: [ComponentBase],
  components: {
    EchartsLayout,
  },
  data() {
    return {
      option: null,
    };
  },
  methods: {
    get_component_data() {
      getCacheOrRequest.call(this, {
        method: "get",
        url: "/org/getStaffNumTop",
        success: (response) => {
          let arr = [];
          response.data &&
            response.data.data &&
            response.data.data.map &&
            response.data.data.map((item) => {
              arr.push({ 从业人员总数: item.staffNum, 机构名: item.orgName });
            });

          // 更新配置
          this.option = {
            grid: { containLabel: true, right: 0, left: 0 },
            series: [
              {
                type: "bar",
                showItemStyle: true,
                barWidth: 50,
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [
                      { offset: 1, color: "rgba(255, 132, 0, 1)" },
                      { offset: 0, color: "rgba(255, 209, 44, 1)" },
                    ],
                    globalCoord: false,
                  },
                  borderRadius: 50,
                },
                encode: { x: "从业人员总数", y: "机构名" },
              },
            ],
            title: { text: "单位：人", textStyle: { fontSize: 54 } },
            tooltip: { textStyle: { fontSize: 30 } },
            xAxis: {
              axisLabel: {
                textStyle: {
                  fontSize: 40,
                  fontWeight: 700,
                },
              },
            },
            yAxis: {
              type: "category",
              inverse: true,
              axisLabel: {
                textStyle: {
                  fontSize: 40,
                  fontWeight: 700,
                },
              },
            },
            dataset: {
              source: [...arr],
            },
          };
        },
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped></style>
